import { render, staticRenderFns } from "./TypingIndicator.vue?vue&type=template&id=2d940ac4&scoped=true"
import script from "./TypingIndicator.vue?vue&type=script&lang=js"
export * from "./TypingIndicator.vue?vue&type=script&lang=js"
import style0 from "./TypingIndicator.vue?vue&type=style&index=0&id=2d940ac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d940ac4",
  null
  
)

export default component.exports